module.exports = __webpack_public_path__ + "static/img/slide_4_en.130e66c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/training/slider/slide_4_en.svg
// module id = wZ6f
// module chunks = 0